/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\User\UserSingle.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday July 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 16th January 2024 12:36:57
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Fragment, useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-number-input";
import { UpdateUserIntel, UpdateUserType, UserSingleType, UserStatus } from "Type/user.type";
import { useLoaderData, useNavigate } from "react-router-dom";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/User/UserSingle.module.css";
import TitlePage from "Content/HeadingPage/TitlePage/TitlePage";
import "react-phone-number-input/style.css";
import "Content/Contact/UserForm/PhoneInput.css";
import UserService from "Services/Users/UserService";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import ModalSearchCompany from "Content/Modals/ModalSearchCompany/ModalSearchCompany";
import { Button, TextField } from "@mui/material";
import { FaPencilAlt } from "react-icons/fa";
import { Form } from "react-bootstrap";
import UserTabs from "./UserTabs/UserTabs";
import { UserFav } from "Type/Favorites.type";
import { UserSeenCarType } from "Type/seenCar.type";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { OfferUserType } from "Type/offer.type";
import SelectCommercial from "./Commercials/SelectCommercial";
import { ModalConfirmRequest } from "Content/Modals/ModalConfirmRequest/ModalConfirmRequest";
import { ModalTransferUser } from "Content/Modals/ModalTransferUser/ModalTransferUser";

function UserSingle() {
    const navigate = useNavigate();
    const loadData = useLoaderData() as {userData: UserSingleType, favorites: UserFav[], usertab: number | undefined, offertab: number | undefined, seenCars: UserSeenCarType[], offers: OfferUserType[]};
    // const loadData = useLoaderData() as {userData: UserSingleType, views: ViewsType[]};
    const createdAt = new Date(loadData.userData.CreatedAt);
    const [updateEmail, setUpdateEmail] = useState(false);
    const [email, setEmail] = useState(loadData.userData.Email);
    const [firstName, setFirstName] = useState(loadData.userData.FirstName);
    const [lastName, setLastName] = useState(loadData.userData.LastName);
    const [phone, setPhone] = useState(loadData.userData.Phone);
    const [cellPhone, setCellPhone] = useState(loadData.userData.CellPhone);
    const [address, setAddress] = useState(loadData.userData.Address);
    const [postalCode, setPostalCode] = useState(loadData.userData.PostalCode);
    const [city, setCity] = useState(loadData.userData.City);
    const [state, setState] = useState(loadData.userData.State);
    const [country, setCountry] = useState(loadData.userData.Country);
    const [comments, setComments] = useState(loadData.userData.Comments);
    const [status, setStatus] = useState(loadData.userData.Status);
    const [updatable, setUpdatable] = useState(false);
    const [buttonEnable, setButtonEnable]  = useState<boolean>(true);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openModalCompany, setOpenModalCompany] = useState<boolean>(false);
    const [openTransferModal, setOpenTransferModal] = useState<boolean>(false);
    const [company, setCompany] = useState<string>(loadData.userData.Company?.Name);
    const [companyID, setCompanyID] = useState<string>(loadData.userData.Company?.id);
    const [commercialHasClients, setCommercialHasClients] = useState<boolean>(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const updateObject = useRef<UpdateUserIntel>({update: {}, add: {groups: [], parameters: []}, remove: {groups: [], parameters: []}});
    const [modalConfig, setModalConfig] = useState<{show: boolean, title: string, additionalMessage?: string, request: () => void }>({ show: false, title: "", request: () => {} });
    const userRole = loadData.userData.UserRole;

    useEffect(() => {
        if (userRole !== "CLIENT") {
            UserService.getUsersByCommercialID(loadData.userData.id, true)
                .then((usersCount) => { if (usersCount > 0) { setCommercialHasClients(true)}})
                .catch(() => setCommercialHasClients(false));
        }
    }, []);

    const setUpdateUserIntelObject = (val: UpdateUserType) => {
        if (val.Email && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(val.Email))
            val.Email = undefined;
            // if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(val.Email))
        updateObject.current.update = {...updateObject.current.update, ...val};
        if (Object.values(updateObject.current.update).some((val) => val !== undefined))
            setUpdatable(true);
        else
            setUpdatable(false);
    };

    const manageSetter = (IsOkay: boolean, OpenModal: boolean, ButtonEnable: boolean) => {
        setIsOkay(IsOkay);
        setOpenModal(OpenModal);
        setButtonEnable(ButtonEnable);
    };

    const manageUpdate = async () => {
        if (Object.values(updateObject.current.update).some((val) => val !== undefined)
            || (updateObject.current.add.groups.length > 0 || updateObject.current.remove.groups.length > 0)
            || (updateObject.current.add.parameters.length > 0 || updateObject.current.remove.parameters.length > 0)) {
            try {
                if (Object.values(updateObject.current.update).some((val) => val !== undefined)) {
                    await UserService.updateUser(loadData.userData.id, updateObject.current.update);
                    updateObject.current.update = {};
                }
                setUpdatable(false);
                manageSetter(true, true, true);
            } catch (reason: any) {
                manageSetter(false, true, true);
            }
        }
    };

    // const handleResendCGV = async () => {
    //     setButtonEnable(false);
    //     UserService.resendCGV(loadData.userData.id).then((res) => {
    //         manageSetter(true, true, true);
    //     }).catch((reason) => {
    //         manageSetter(false, true, true);
    //     });
    // };

    const handleCloseModalCompany = () => {
        setOpenModalCompany(false);
    };

    const handleModalClose = () => {
        setOpenModal(false);
        closeConfirmModal();
    };

    const handleTransferModalClose = () => {
        setOpenTransferModal(false);
    };

    const openConfirmModal = (title: string, request: () => void, additionalMessage?: string,) => {
        setModalConfig({
        show: true,
        title,
        additionalMessage,
        request,
      });
    };

    const closeConfirmModal = () => {
      setModalConfig((prev) => ({ ...prev, show: false }));
    };

    const handleResendEmailVerification = () => {
        setButtonEnable(false);
        UserService.resendEmailVerification(loadData.userData.id).then((res) => {
            manageSetter(true, true, true);
        }).catch(() => {
            manageSetter(false, true, true);
        });
    };

    const handleUpdateStatus = (status: UserStatus) => {
        setButtonEnable(false);
        UserService.updateStatus(loadData.userData.id, status).then((res) => {
            manageSetter(true, true, true);
            setStatus(status);
        }).catch(() => {
            manageSetter(false, true, true);
        });
    };

    const handleDeleteUser = (userID: string) => {
        setButtonEnable(false);
        UserService.deleteUser(userID).then((res) => {
            manageSetter(true, true, true);
            setTimeout(() => navigate(-1), 5000);
        }).catch(() => {
            manageSetter(false, true, true);
        });
    };

    // const handleIDFileDownload = async () => {
    //     setButtonEnable(false);
    //     if (loadData.userData.IDFilePath)  {
    //         try {
    //             var response = await axios.get(`https://${loadData.userData.IDFilePath}`, {...buildAxiosHeader(), "responseType": "blob"});
    //             const href = URL.createObjectURL(response.data);
    //             const link = document.createElement('a');
    //             link.href = href;
    //             link.setAttribute('download', 'CI.pdf');
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);
    //             URL.revokeObjectURL(href);
    //             setButtonEnable(true);
    //         } catch (e: any) {
    //             console.error(`Error while pulling file: ${JSON.stringify(e)}`);
    //             manageSetter(false, true, true);
    //         }
    //     } else
    //         manageSetter(false, true, true);
    // };

    return (
        <Fragment>
            <div className="p-3">
                <TitlePage title={translator.decode("dynamic.user")} />
                <div className={`${Styles.actionHolder}`}>
                    <span className={`${Styles.action}`}>
                        {(status === "ARCHIVED" && commercialHasClients) ?
                            <button disabled={!buttonEnable} className="btn btn-outline-warning" onClick={(e) => {e.stopPropagation(); setOpenTransferModal(true)}}>{translator.decode("users.button_transfer")}</button>
                            : null
                        }
                        {status === "NEW" ?
                            <button disabled={!buttonEnable} className="btn btn-outline-info" onClick={async (e) => {e.stopPropagation(); handleResendEmailVerification();}}>{translator.decode("users.sendVerificationLink")}</button>
                            : null
                        }
                        {(status === "PENDING" || status === "ARCHIVED") ?
                            <button disabled={!buttonEnable} className="btn btn-outline-success" onClick={(e) => {e.stopPropagation(); manageUpdate(); handleUpdateStatus(UserStatus.VALID)}}>{translator.decode("dynamic.valid")}</button>
                            : null
                        }
                        {status !== "ARCHIVED" ?
                            <button disabled={!buttonEnable} className="btn btn-outline-danger" onClick={(e) => {e.stopPropagation(); handleUpdateStatus(UserStatus.ARCHIVED);}}>{translator.decode("dynamic.archive")}</button>
                            : null
                        }
                        {(status === "ARCHIVED" && !commercialHasClients) ?
                            <button disabled={!buttonEnable} className="btn btn-outline-danger" onClick={(e) => {e.stopPropagation(); openConfirmModal(translator.decode("users.button_delete"), () => handleDeleteUser(loadData.userData.id))}}>{translator.decode("dynamic.delete")}</button>
                            : null
                        }
                        <button disabled={!buttonEnable || !updatable} className="btn btn-outline-info" onClick={() => openConfirmModal(translator.decode("users.save_confirm").replace("%s", Object.keys(updateObject.current.update).join(", ")), manageUpdate)}>{translator.decode("dynamic.save")}</button>
                        {/* <button disabled={!buttonEnable} className="btn btn-outline-info" onClick={(e) => handleIDFileDownload()}>{translator.decode("users.downloadIDFile")}</button> */}
                    </span>
                </div>
                <div className={`${Styles.holderUser} mb-3`}>
                    <div className={`${Styles.block}`}>
                        <h3>
                            {translator.decode("dynamic.general")}
                        </h3>
                        <div className={`${Styles.block}`}>
                            <div> {translator.decode("dynamic.createdAt")} {createdAt.toLocaleDateString()} </div>
                            {updateEmail ?
                                <Form.Group className={`${Styles.formfield}`} >
                                    <TextField label={translator.decode("dynamic.email")} sx={{width:"100%"}} size="small" required type={"email"} value={email ?? ""} onChange={(e) => {setEmail(e.target.value); setUpdateUserIntelObject({Email: e.target.value})}} />
                                </Form.Group>
                                :
                                <div className="d-inline-flex">
                                    <div style={{fontWeight:"bold"}}><p className="m-0">{translator.decode("dynamic.email")}: <span className={`${Styles.bold}`}>{loadData.userData.Email}</span></p></div>
                                    <Button onClick={(e) => setUpdateEmail(true)}>
                                        <FaPencilAlt />
                                    </Button>
                                </div>
                            }
                            <div className={`${Styles.company}`}>
                                <div style={{cursor:"pointer"}} onClick={()=> {navigate(RouterPathResolver.pathCompany_BY_ID.path.replace(":id", companyID))}}> {translator.decode("dynamic.company")}: {company.toUpperCase()} </div>
                                {/* <button disabled={!buttonEnable} className="btn btn-outline-info"><a href={loadData.userData.Company.KBISPath} target="_blank" >{translator.decode("dynamic.kbis")}</a></button> */}
                                <Button onClick={() => setOpenModalCompany(true)}>
                                    <FaPencilAlt />
                                </Button>
                            </div>
                            <SelectCommercial valueName="CommercialID" onUpdate={setUpdateUserIntelObject} className={Styles.select} CommercialID={loadData.userData.CommercialID!} label={translator.decode("dynamic.commercial")} />
                            {/* <SelectCommercial valueName="FlyingCommercialID" onUpdate={setUpdateUserIntelObject} className={Styles.select} CommercialID={loadData.userData.FlyingCommercialID!} label={translator.decode("dynamic.flyingCommercial")} /> */}
                        </div>
                        <div className={`${Styles.status}`}>
                            {translator.decode("dynamic.status")}: {translator.decode(`dynamic.${loadData.userData.Status}`)}
                            {status === "NEW" ? <span className="text-danger"> {translator.decode("dynamic.newAccount")} </span> : null}
                        </div>
                        <div className={`${Styles.status}`}>
                            <span>{translator.decode("users.SellAgreement")}:</span>{loadData.userData.SellAgreementTime ? new Date(loadData.userData.SellAgreementTime).toLocaleString(): null}
                        </div>
                        <div className={`${Styles.status}`}>
                            <span>{translator.decode("users.CommercialCall")}:</span>{loadData.userData.CommercialCallTime ? new Date(loadData.userData.CommercialCallTime).toLocaleString(): null}
                        </div>
                        <div className={`${Styles.status}`}>
                            <span>{translator.decode("users.lastConnexion")}:</span>{(loadData.userData.ConnexionList && loadData.userData.ConnexionList.length > 0 ? new Date(loadData.userData.ConnexionList.sort((val1, val2) => {return (new Date(val1.Date)).getTime() - (new Date(val2.Date)).getTime()}).reverse()[0].Date): "").toLocaleString()}
                        </div>
                    </div>
                    <div className={`${Styles.block}`}>
                        <h3>
                            {translator.decode("dynamic.information")}
                        </h3>
                        <div className={`${Styles.personalInfo}`}>
                            <div>
                                <p>{translator.decode("dynamic.lastname")}:</p>
                                <input type="text" value={lastName} onChange={(e) => {setLastName(e.target.value); setUpdateUserIntelObject({LastName: e.target.value});}}/>
                            </div>
                            <div>
                                <p>{translator.decode("dynamic.firstname")}:</p>
                                <input type="text" value={firstName} onChange={(e) => {setFirstName(e.target.value); setUpdateUserIntelObject({FirstName: e.target.value});}}/>
                            </div>
                            <div>
                                <p>{translator.decode("dynamic.phone")}:</p>
                                <PhoneInput defaultCountry="FR" autoComplete="on" value={phone} onChange={(e: any) => {setPhone(e); setUpdateUserIntelObject({Phone: e})}}  />
                            </div>
                            <div>
                                <p>{translator.decode("dynamic.cellPhone")}:</p>
                                <PhoneInput defaultCountry="FR" autoComplete="on" value={cellPhone} onChange={(e: any) => {setCellPhone(e); setUpdateUserIntelObject({CellPhone: e})}} />
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.block}`}>
                        <h3>
                            {translator.decode("dynamic.address")}
                        </h3>
                        <div className={`${Styles.address}`}>
                            <div><p>{translator.decode("dynamic.street")}:</p> <input type="text" value={address} onChange={(e) => {setAddress(e.target.value); setUpdateUserIntelObject({Address: e.target.value})}}/></div>
                            <div><p>{translator.decode("dynamic.postalcode")}:</p> <input type="text" value={postalCode} onChange={(e) => {setPostalCode(e.target.value); setUpdateUserIntelObject({PostalCode: e.target.value})}}/></div>
                            <div><p>{translator.decode("dynamic.city")}:</p> <input type="text" value={city} onChange={(e) => {setCity(e.target.value); setUpdateUserIntelObject({City: e.target.value})}}/></div>
                            <div><p>{translator.decode("dynamic.state")}:</p> <input type="text" value={state ?? "N/C"} onChange={(e) => {setState(e.target.value); setUpdateUserIntelObject({State: e.target.value})}}/></div>
                            <div><p>{translator.decode("dynamic.country")}:</p> <input type="text" value={country} onChange={(e) => {setCountry(e.target.value); setUpdateUserIntelObject({Country: e.target.value})}}/></div>
                        </div>
                    </div>
                </div>
                <div className="m-3">
                    <p>{translator.decode("dynamic.comment")}:</p>
                    <textarea className={`w-100`} maxLength={1024} value={comments} onChange={(e) => {setComments(e.target.value); updateObject.current.update.Comments = e.target.value; setUpdateUserIntelObject({Comments: e.target.value})}} />
                </div>
                {/* <div className="p-3">
                    <GroupList title={"dynamic.groups"} groups={userGroups.current.map(val => {return {id: val.GroupID, Name: ""}} )} callback={updateUserGroup} />
                </div> */}
                {/* <div className="p-3">
                    <UserParameters user={loadData.userData.UserParameters} callback={updateUserParameters} />
                </div> */}
                {/* <hr /> */}
                {/* <div className="d-flex flex-row justify-content-around">
                    <div>
                        <h5>
                            {translator.decode("dynamic.offers")} {loadData.userData.Offer.length}
                        </h5>
                        <Offer userID={loadData.userData.id} offers={loadData.userData.Offer} showVehicleData={true} showSellName={true} />
                    </div>
                    <div>
                        <h5>
                            {translator.decode("dynamic.views")} {views.current.length}
                        </h5>
                        <ViewsCar views={views.current} showCarInfo={true} />
                    </div>
                </div> */}
            </div>
            <hr />
            {/* <div className="mb-5">
                <ConnexionComponent userID={loadData.userData.id} displayName={false} page={1} showTitle={false} />
            </div> */}
            {/* <UserTabs userID={loadData.userData.id} offers={loadData.userData.Offer} SeenCar={loadData.userData.SeenCar} fav={loadData.favorites} usertab={loadData.usertab} offertab={loadData.offertab} /> */}
            <UserTabs userID={loadData.userData.id} SeenCar={loadData.seenCars} fav={loadData.favorites} usertab={loadData.usertab} offertab={undefined} />
            <ModalSearchCompany setCompanyID={setCompanyID} setCompany={setCompany} ClientID={loadData.userData.id} show={openModalCompany} onClose={handleCloseModalCompany} closeModal={handleCloseModalCompany} title={""} submitFunc={UserService.updateUser} />
            <ModalConfirmation show={openModal} onClose={handleModalClose} closeModal={handleModalClose} isOkay={isOkay} />
            <ModalTransferUser show={openTransferModal} onClose={handleTransferModalClose} oldCommercialID={loadData.userData.id} setButtonEnable={setButtonEnable} />
            <ModalConfirmRequest show={modalConfig.show} onClose={closeConfirmModal} closeModal={closeConfirmModal} request={modalConfig.request} title={modalConfig.title} />
        </Fragment>
    )
}

export default UserSingle;
